export enum RestorationTypesEnum {
	ScrewRetained = 1,
	CementRetained = 2,
	ScrewCementRetained = 3

}